/*!
  _   _  ___  ____  ___ ________  _   _   _   _ ___   
 | | | |/ _ \|  _ \|_ _|__  / _ \| \ | | | | | |_ _| 
 | |_| | | | | |_) || |  / / | | |  \| | | | | || | 
 |  _  | |_| |  _ < | | / /| |_| | |\  | | |_| || |
 |_| |_|\___/|_| \_\___/____\___/|_| \_|  \___/|___|
                                                                                                                                                                                                                                                                                                                                       
=========================================================
* Horizon UI - v1.1.0
=========================================================

* Product Page: https://www.horizon-ui.com/
* Copyright 2023 Horizon UI (https://www.horizon-ui.com/)

* Designed and Coded by Simmmple

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// Chakra imports
import {
  Avatar,
  Box,
  Flex,
  FormLabel,
  Icon,
  IconButton,
  Select,
  SimpleGrid,
  useColorModeValue,
  Image,
  Text,
} from "@chakra-ui/react";
// Assets
import ChipLogo from "assets/img/chip_ellipse_yellow.png";
import { APIProvider, Map, Marker, InfoWindow } from "@vis.gl/react-google-maps";
// Custom components
import MiniStatistics from "components/card/MiniStatistics";
import IconBox from "components/icons/IconBox";
import React, { useEffect, useState }from "react";
import {
  MdAddTask,
  MdFence,
  MdFileCopy,
} from "react-icons/md";

import {
  TbCell
} from "react-icons/tb"
import { FaUser } from "react-icons/fa6";

// Utils
import { formatLastSeen } from "utils/dateUtils";

export default function UserReports() {
  const position = {lat: 58.33, lng: 8.57}
  // Chakra Color Mode
  const brandColor = useColorModeValue("brand.500", "white");
  const boxBg = useColorModeValue("secondaryGray.300", "whiteAlpha.100");

  const [chipData, setChipData] = useState([]);
  const [activeChip, setActiveChip] = useState(null);

  const authToken = localStorage.getItem('authToken');

  // fetch chips
  useEffect(() => {
    const options = {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${authToken}`
      } 
    }
    
    fetch(`https://api.beehiveproject.no/chip`, options)
    .then(response => response.json(), )
    .then(data => {
      setChipData(data);
    })
    .catch(error => console.log(error));
  }, [authToken]);

  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <SimpleGrid
        columns={{ base: 1, md: 2, lg: 3, "2xl": 6 }}
        gap='20px'
        mb='20px'>
        <MiniStatistics
          startContent={
            <IconBox
              w='56px'
              h='56px'
              bg={boxBg}
              icon={
                <Icon w='32px' h='32px' as={TbCell} color={brandColor} />
              }
            />
          }
          name='Chipper'
          value={chipData.length.toString()}
        />
        {/*TODO: Add more stats here*/}
      </SimpleGrid>
      {/* TODO: As of February 21st, 2024, google.maps.Marker is deprecated. Please use google.maps.marker.AdvancedMarkerElement instead. */}
      <APIProvider apiKey={'AIzaSyA9n8R_h56nRdg8p0Pf6rjTV_Ic0xqisTk'}>
        <Map style={{width: '87vw', height: '80vh'}} defaultCenter={position} defaultZoom={16}></Map>
        {chipData.map((chip) => (
          <Marker 
            key={chip._id.$oid}
            position={{ lat: Number(chip.last_position[0]), lng: Number(chip.last_position[1]) }} 
            icon={ChipLogo} 
            onMouseOver={() => setActiveChip(chip)}
          />
          
        ))}
        {activeChip && (
        <InfoWindow
          position={{ lat: activeChip.last_position[0]+0.0001, lng: activeChip.last_position[1] }}
          onCloseClick={() => setActiveChip(null)}
          display='hidden'
        >
          <div
            style={{
              padding: '8px 12px',
              borderRadius: '8px',
              fontSize: '14px',
            }}
          >
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              <li style={{ marginBottom: '4px' }}>
                <strong>Chip ID: </strong> {activeChip.chip_id}
              </li>
              <li style={{ marginBottom: '4px' }}>
                <strong>Sist Sett: </strong> {`${formatLastSeen(activeChip.last_position_gotten_at?.$date)}`}
              </li>
            </ul>
          </div>
        </InfoWindow>
        )}
      </APIProvider>
    </Box>
  );
}
